<template>
  <div>
    <div
      :class="
        data.isFullScreen
          ? 'isThisForMeContainer fullscreened'
          : 'isThisForMeContainer'
      "
    >
      <div class="headingContainer">
        <slot name="crossButton"></slot>
        <img src="../assets/isThisForMe.svg" />
        <h1>{{$t('About this event')}}</h1>
        <div>{{ data.aboutTheEvent }}</div>
      </div>
      <div class="subContainers">
        <div
          class="subContianer"
          v-for="(subItem, index) in data.subItems"
          :key="index"
        >
          <div class="subContainerHeader">{{ subItem.header }}</div>
          <div class="subContainerBody">
            <ul v-if="!subItem.isSurveyItems">
              <li v-for="(bodyItem, indexx) in subItem.bodyItems" :key="indexx">
                <span v-if="subItem.isLinkItems">
                  <div class="linkText" @click="navigateToTime(bodyItem.time)">{{bodyItem.header}}</div>
                  {{bodyItem.extraText}}
                </span>
                <span v-else>{{ bodyItem }}</span>
              </li>
            </ul>
          <div v-if="subItem.isSurveyItems">
            <div class="statsContainer" v-for="(stat,index) in surveyItemsData" :key="index">
              <poll-overlay :InstanceData="stat"></poll-overlay>
            </div>
          </div>
          </div>
        </div>
      </div>
      <slot name="backToTopButton"></slot>
    </div>
  </div>
</template>
<script>
import "../scss/is-this-for-me.css";
import pollOverlay from './poll-overlay.vue';
import timeMixin from '../mixins/timeMixin'

export default {
  components: { pollOverlay },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttonClickedEvent(e) {
      if (!this.data.isFullScreen && e.detail.state == "clicked") {
        this.scrollSaveCount = this.$parent.saveScrollState(this);
        if(this.initialPrefs.showDesktopOverlays){
          let customEvent = new CustomEvent("openDesktopOverlay", {
            detail: {
              component: "isThisForMe",
              data: {
                ...this.data,
                isFullScreen: true,
              },
            },
          });
          this.$root.$emit('pauseVideo') 
          window.dispatchEvent(customEvent);
        }
      }
    },
    resize(){
      this.$parent.resize()
    },
    navigateToTime(time){
      this.$root.$emit('seekVideo',this.convertHoursMinsSecsToSeconds(time)) 
      this.$root.$emit('playVideo') 
    }
  },
  mixins:[timeMixin],
  created() {
    window.addEventListener("isThisForMeButtonEvent", this.buttonClickedEvent);
    let items=this.data.subItems.find(x=>x.isSurveyItems)
    if(items!=null){
      for(var i=0;i<items.surveyIds.length;i++){
        this.surveyItemsData.push({
          "pollId": items.surveyIds[i],
          "allowMultiple": false,
          "allowEmpty": false,
          "noSkipButton": false,
          "isEmbedded":true
        })
      }
    }
  },
  data() {
    return {
      surveyItemsData: []
    }
  }
};
</script>

<style>
</style>
